import { Redirect } from 'react-router-dom'
import { InsuredInformationBreadcrumb } from 'quick-quote/components'

import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import PATH from 'quick-quote/constants/path'
import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import BasicPlanSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan-selection'
import ModelFactorSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import BasicPlan from './basic-plan/basic-plan'

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  canProceedToCoveragePlan,
  editRiderSumAssured,
  editRiderSelectedPlan,
  basicPlanOptions,
  selectedBasicPlanCode,
  updateSelectedBasicPlan,
  basicPremiumState,
  haveBasicPremiumState,
  readOnlyFields,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }

  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <div id="basic-plan">
            <div className="content">
              <ModelFactorSelection />
              <BasicPlanSelection
                basicPlanOptions={basicPlanOptions}
                selectedBasicPlanCode={selectedBasicPlanCode}
                basicPlanValidationError={''}
                editSelectedPlan={updateSelectedBasicPlan}
              />
              <BasicPlan
                basicPremiumState={basicPremiumState}
                haveBasicPremiumState={haveBasicPremiumState}
                readOnlyFields={readOnlyFields}
              />
            </div>
          </div>

          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
